<div class="header">
    <h2>{{ 'courses.modal.add.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="courses-add-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'courses.fieldset.basic' | translate }}</h2>
        <app-form-input
            [control]="form.controls.name"
            [label]="'courses.form.name' | translate"
            [placeholder]="'courses.form.name.placeholder' | translate"
            inputId="name"
            testId="courses-add-name"
        />

        <app-form-textarea
            [control]="form.controls.description"
            [label]="'courses.form.description' | translate"
            [placeholder]="'courses.form.description.placeholder' | translate"
            inputId="description"
            testId="courses-add-description"
        />

        <app-form-select
            [control]="form.controls.type"
            [label]="'courses.form.type' | translate"
            [options]="typeOptions"
            inputId="type"
            testId="courses-add-type"
        />

        <app-form-select
            [control]="form.controls.instructorId"
            [label]="'courses.form.instructor' | translate"
            [options]="instructors()"
            [placeholder]="'courses.form.instructor.placeholder' | translate"
            inputId="instructorId"
            testId="courses-add-instructor-id"
        />

        <app-form-datepicker
            [control]="form.controls.deadline"
            [label]="'courses.form.deadline' | translate"
            [placeholder]="'courses.form.deadline.placeholder' | translate"
            [minDate]="minDeadline"
            inputId="deadline"
            testId="courses-add-deadline"
        />

        <app-form-toggle-switch
            [control]="form.controls.orderRestricted"
            [label]="'courses.form.orderRestricted' | translate"
            [description]="'courses.form.orderRestricted.description' | translate"
            inputId="orderRestricted"
            testId="courses-add-order-restricted"
        />
    </div>

    <app-course-module-list
        [modules]="selectedModules()"
        testId="courses-add-modules"
        (add)="openModuleDialog()"
        (remove)="removeModule($event)"
        (reorder)="reorderModules($event)"
    />

    <div class="section">
        <app-material-list
            [materialIds]="form.controls.materialIds.value"
            titleKey="courses.fieldset.materials"
            addLabelKey="courses.form.addMaterial"
            emptyKey="courses.materials.empty"
            testId="courses-add-materials"
            (add)="onSelectMaterial()"
            (remove)="removeMaterial($event)"
            (reorder)="reorderMaterials($event)"
        />
    </div>

    <div class="section">
        <h2>{{ 'courses.fieldset.images' | translate }}</h2>
        <div class="uploads">
            <div class="media-field">
                <span class="label">{{ 'courses.form.placeholder' | translate }}</span>
                @if (form.controls.mediaPlaceholderId.value; as placeholderId) {
                    <div class="media-preview landscape">
                        <app-media-image [mediaId]="placeholderId" [alt]="'courses.form.placeholder' | translate" />
                    </div>
                }
                <p-button
                    [label]="'courses.form.selectPlaceholder' | translate"
                    icon="pi pi-image"
                    [outlined]="true"
                    severity="secondary"
                    data-test="courses-add-select-placeholder"
                    (onClick)="onSelectMedia('mediaPlaceholderId', 'image')"
                />
            </div>
            <div class="media-field">
                <span class="label">{{ 'courses.form.placeholderPortrait' | translate }}</span>
                @if (form.controls.mediaPlaceholderPortraitId.value; as placeholderId) {
                    <div class="media-preview portrait">
                        <app-media-image [mediaId]="placeholderId" [alt]="'courses.form.placeholderPortrait' | translate" />
                    </div>
                }
                <p-button
                    [label]="'courses.form.selectPlaceholderPortrait' | translate"
                    icon="pi pi-image"
                    [outlined]="true"
                    severity="secondary"
                    data-test="courses-add-select-placeholder-portrait"
                    (onClick)="onSelectMedia('mediaPlaceholderPortraitId', 'image')"
                />
            </div>
        </div>
    </div>
</form>

<div class="footer">
    <p-button [label]="'courses.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="courses-add-cancel" (onClick)="close()" />
    <p-button
        type="submit"
        [label]="'courses.form.create' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="courses-add-submit"
        (onClick)="onSubmit()"
    />
</div>
